<template>
  <div style="padding: 10px;">
    <!-- 采购对公付款申请单 -->
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>采购对公付款申请单</b>
      </div>
      <div>
        <el-form ref="form" :model="form" label-width="140px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="单据编号" prop="ccode">
                <el-input v-model="form.ccode" placeholder="单据编号" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="公司" prop="ccorpname">
                <el-input v-model="form.ccorpname" placeholder="公司" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请日期" prop="ddate">
                <el-input v-model="form.ddate" placeholder="申请日期" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请人" prop="cmaker">
                <el-input v-model="form.cmaker" placeholder="申请人" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="费用项目" prop="ccostitems">
                <el-input v-model="form.ccostitems" placeholder="费用项目" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据类型" prop="cdocumenttype">
                <el-input v-model="form.cdocumenttype" placeholder="单据类型" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="付款币种" prop="ccurrency">
                <el-input v-model="form.ccurrency" placeholder="付款币种" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="核算主体" prop="ctcbs">
                <el-input v-model="form.ctcbs" placeholder="核算主体" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="部门" prop="cdepname">
                <el-input v-model="form.cdepname" placeholder="部门" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商" prop="cvenname">
                <el-input v-model="form.cvenname" placeholder="供应商" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="申请说明" prop="cremarks">
                <el-input type="textarea" v-model="form.cremarks" placeholder="申请说明" :rows="3" maxlength="300"
                  show-word-limit readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请付款金额" prop="iprepaidfees">
                <el-input v-model="form.iprepaidfees" placeholder="申请付款金额" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="本次核销预付金额" prop="ibchxje">
                <el-input v-model="form.ibchxje" placeholder="本次核销预付金额" readonly />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="待核销预付金额" prop="idhxje">
                <el-input v-model="form.idhxje" placeholder="待核销预付金额" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="付款金额" prop="ipaymentmoney">
                <el-input v-model="form.ipaymentmoney" placeholder="付款金额" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="员工" prop="cstaffname">
                <el-input v-model="form.cstaffname" placeholder="员工" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="费用归属部门" prop="cfygsdep">
                <el-input v-model="form.cfygsdep" placeholder="费用归属部门" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="成本中心" prop="ccostcenter">
                <el-input v-model="form.ccostcenter" placeholder="成本中心" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="费控单号" prop="cfccode">
                <el-input v-model="form.cfccode" placeholder="费控单号" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="提交费控日期" prop="dfcdate">
                <el-input v-model="form.dfcdate" placeholder="提交费控日期" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="审核结果" prop="cauditresult">
                <el-input v-model="form.cauditresult" placeholder="审核结果" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div id="out-table">
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <b><i class="el-icon-s-unfold"></i>费用行信息</b>
        </div>
        <el-table border :data="dtDet" style="width: 100%;min-height: 200px;max-height: 500px;">
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="付款状态" align="center" prop="cpaymenttype" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="SAP发票单号" align="center" prop="csapfpcode" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="总金额" align="center" prop="imoney" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="已申请金额" align="center" prop="iysqmoney" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="本次申请付款金额" align="center" prop="ibcsqmoney" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="可申请付款金额" align="center" prop="isqyfmoney" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="过账日期" align="center" prop="dgz" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="账期天数" align="center" prop="izqday" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="付款计划日" align="center" prop="dfkjhr_det" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="使用发票日期" align="center"
            min-width="120">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.bfpdate" disabled></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="说明" align="center" prop="cremarks_det" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="采购业务员" align="center" prop="ccgywy" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="发票日期" align="center" prop="dfpdata" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="费用归属期间" align="center" prop="dfygs" :show-overflow-tooltip="true" min-width="120" />
        </el-table>
      </el-card>
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <b><i class="el-icon-s-unfold"></i>付款行信息</b>
        </div>
        <el-table border :data="dtFkh" style="width: 100%;min-height: 200px;max-height: 500px;" height="350px">
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="付款方式" align="center" prop="cpaymentmethod" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="付款用途" align="center" prop="cpaymentpurpose" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="银行账号" align="center" prop="caccountnumber" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="账户持有人" align="center" prop="caccount" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="银行行号" align="center" prop="cbankcode" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="付款计划日" align="center" prop="dfkjhr" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="实付款金额" align="center" prop="iapa" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="核销金额" align="center" prop="iwoamount" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="付款行备注" align="center" prop="cremarks_fkh" :show-overflow-tooltip="true"
            min-width="120" />
        </el-table>
      </el-card>
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <b><i class="el-icon-s-unfold"></i>待核销预付款</b>
        </div>
        <el-table border :data="dtDhxyfk" style="width: 100%;min-height: 200px;max-height: 500px;" height="400px">
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="付款行号" align="center" prop="ifksort" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="预付款申请单单号" align="center" prop="cadvancecode" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="预付款申请单行号" align="center" prop="cadvancedetsortno" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="SAP订单号" align="center" prop="cordcode" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="订单日期" align="center" prop="dorddata" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="订单金额" align="center" prop="iordmoney" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="可核销金额" align="center" prop="ikhxje" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="本次核销金额" align="center" prop="ibchxje_dhxyfk" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="已申请预付金额" align="center" prop="iysqyfje" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="已核销金额" align="center" prop="iyhxje" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="申请日期" align="center" prop="dsqdata" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="申请人" align="center" prop="csqr" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="明细备注" align="center" prop="cremarks_dhxfk" :show-overflow-tooltip="true"
            min-width="120" />
        </el-table>
      </el-card>
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <b><i class="el-icon-s-unfold"></i>附件信息</b>
        </div>
        <el-table border :data="dtFile" style="width: 100%;min-height: 200px;max-height: 500px;" height="400px">
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="附件名称" align="center" prop="cfilename" :show-overflow-tooltip="true" min-width="220" />
          <el-table-column label="附件路径" align="center" prop="cfilepath" :show-overflow-tooltip="true" min-width="220" />
          <el-table-column label="上传人" align="center" prop="coper" :show-overflow-tooltip="true" min-width="100" />
          <el-table-column label="上传时间" align="center" prop="dupload" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="操作" align="center" width="130" class-name="small-padding fixed-width" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" icon="el-icon-edit" @click="handCK(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <b><i class="el-icon-s-unfold"></i>银行汇票</b>
        </div>
        <el-table border :data="dtDraft" style="width: 100%;min-height: 200px;max-height: 500px;" height="400px">
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="银行汇票" align="center" prop="cbankdraft" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="路径" align="center" prop="cdraftpath" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="接收日期" align="center" prop="dreceive" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="操作" align="center" width="130" class-name="small-padding fixed-width" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" icon="el-icon-edit" @click="handYHHP(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card boxcard" style="height: 500px;">
        <div slot="header" class="clearfix">
          <b><i class="el-icon-s-unfold"></i>发票信息</b>
        </div>
        <el-table border :data="dtFp" show-summary :summary-method="getSummariesFP"
          style="width: 100%;min-height: 200px;max-height: 350px;" :max-height="350">
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="发票号" align="center" prop="cbillcode" :show-overflow-tooltip="true" min-width="180" />
          <el-table-column label="发票代码" align="center" prop="cinvoicecode" :show-overflow-tooltip="true"
            min-width="120" />
          <el-table-column label="发票金额" align="center" prop="ibillamount" :show-overflow-tooltip="true"
            min-width="100" />
          <el-table-column label="税额" align="center" prop="itax" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="不含税金额" align="center" prop="inotax" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="发票日期" align="center" prop="dbilldate" :show-overflow-tooltip="true" min-width="120" />
          <el-table-column label="供应商" align="center" prop="cannulname" :show-overflow-tooltip="true" min-width="220" />
          <el-table-column label="供应商税号" align="center" prop="cannulid" :show-overflow-tooltip="true" min-width="220" />
          <el-table-column label="操作" align="center" width="130" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button size="mini" type="text" icon="el-icon-edit" @click="handCK(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { RemovePruchaseToDo, GetFileType } from "@/api/home";
  export default {
    data() {
      return {
        form: {
          ccode: '',
          ctcbs: '',
          ddate: '',
          cstaffname: '',
          ccurrency: '',
          iprepaidfees: '',
          cpaymentmethod: '',
          cdepname: '',
          cremarks: '',
          cvenname: '',
          caccountnumber: '',
          caccount: '',
          cbankcode: '',
          ipaymentmoney: '',
          cdocumenttype: '',
          cfundingplan: '',
          cbusinesstype: '',
          cfccode: '',
          dfcdate: '',
          cauditresult: '',
        },
        activeName: '订单明细',
        dtDet: [],
        dtDraft: [],
        dtFile: [],
        dtDhxyfk: [],
        dtFkh: [],
        dtFp: [],
        loading: true,
        keyid: '',
        userCode: '',
      };
    },
    created() {
      this.keyid = this.$route.query.keyid;
      this.SRMFC = this.$route.query.SRMFC;
      console.log(this.keyid, this.SRMFC, '434543')
      this.GetInquiryInfo();
    },

    methods: {
      getSummariesFP(param) {
          const { columns, data } = param;
          const sums = [];
          columns.forEach((column, index) => {
              if (index === 0) {
                  sums[index] = '合计';
                  return;
              }
              if (index === 1 || index === 2 || index === 6 || index === 7 || index === 8 || index === 9) {
                  sums[index] = "";
                  return;
              }
              
              const values = data.map(item => {
                  const num = Number(item[column.property]);
                  return isNaN(num) ? 0 : num; // 将非数值转换为0，避免影响计算
              });
              
              if (values.some(value => value !== 0)) { // 检查是否有有效数值
                  const sum = values.reduce((prev, curr) => prev + curr, 0);
                  sums[index] = sum.toFixed(2) + ' 元'; // 保留2位小数
              } else {
                  sums[index] = 'N/A';
              }
          });
      
          return sums;
      },
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      handCK(row) {
        console.log(row)
        window.open('https://srm.ryytngroup.com/' + row.cfilepath);
      },
      handYHHP(row) {
        console.log(row)
        window.open(row.cdraftpath);
      },
      // 获取信息
      GetInquiryInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/FC/GetCorporatePaymentInfo",
          headers: {
            'x-srm-signature': this.SRMFC
          },
          data: { keyid: this.keyid },
        }).then((res) => {
          console.log(res, "获取信息结果");
          if (res.data.Success) {
            this.form = res.data.Data.dtMain[0];
            this.dtFile = res.data.Data.dtFile;
            this.dtDraft = res.data.Data.dtDraft;
            this.dtDet = res.data.Data.dtDet;
            for(var i=0;i<this.dtDet.length;i++){
              this.dtDet[i].bfpdate=this.dtDet[i].bfpdate=="true"?true:false;
            }
            this.dtFkh = res.data.Data.dtFkh;
            this.dtDhxyfk = res.data.Data.dtDhxyfk;
            this.dtFp = res.data.Data.dtFp;
            console.log(this.dtFp, '发票信息')
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
    },
    beforeDestroy() {
      this.informdata = {};
    },

  };
</script>
<style scoped>
  .el-form-item {
    margin-bottom: 10px;
    font-weight: 900;
  }

  .el-card__header .clearfix span {
    font-size: 12px;
  }

  .Projectdetails>>>.el-input__inner {
    border: 0;
    background: #f7f7f7;
  }

  .tb-edit .el-input,
  .tb-edit .el-select,
  .tb-edit .el-textarea {
    display: none;
  }

  .tb-edit .current-row .el-input,
  .tb-edit .current-row .el-select,
  .tb-edit .current-row .el-textarea {
    display: block;
  }

  .tb-edit .current-row .el-input+span,
  .tb-edit .current-row .el-select+span,
  .tb-edit .current-row .el-textarea+span {
    display: none;
  }

  .infodata {
    margin-bottom: 10px;
  }

  .infodata span {
    margin: 0 10px;
  }

  .Projectdetails /deep/ .el-input.is-disabled /deep/ .el-input__inner {
    border-color: transparent;
    background: transparent;
    color: #606266;
  }

  .el-table {
    overflow: visible !important;
  }
</style>